/**************
 Menu Scroll
 ***************/

const header = document.querySelector('#header');
// is this a customer page? Ignore scroll change
const customerPage = header.classList.contains('customerPage');

if (!customerPage) {
// on scroll, when moving down,hide menu. On scroll up, roll menu back
//get the initial height from top to bottom of header for comparison. Check for announcment bar too
    const headerAnnouncementHeight = header.offsetHeight + (document.querySelector('#announcement').offsetHeight || 0);

// follow the current window location
    let windowTop = 0;
    window.addEventListener('scroll', () => {
        // add scroll class to header, changes the icon
        if (window.scrollY >= headerAnnouncementHeight) {
            header.querySelector('#headerLogo').classList.add('scroll');
            // check for scrolling down or up and hide/show header accordingly
            if (!header.querySelector('#headerNavShopMenu').classList.contains('active')) {
                window.scrollY > windowTop
                    ? header.style.transform = 'translateY(-110%)'
                    : header.style.transform = 'translateY(0)';
            }

        } else {
            header.querySelector('#headerLogo').classList.remove('scroll');
            header.style.transform = 'transform: translateY(0)';
        }
        // reset current comparison
        windowTop = window.scrollY;
    })
}

/*********
 Mega Menu
 *********/

// hovering over shop opens menu and sets height
document.querySelector('#headerNavShop').addEventListener('mouseover', function () {
    document.querySelector('#headerNavShopMenu').classList.add('active')
    document.querySelector('#headerNavShopMenu').style.height =
        `${window.innerHeight - header.getBoundingClientRect().bottom}px`;
    document.querySelector('body').classList.add('noScroll');
    customerPage ? header.style.backgroundColor = '#fff' : "";
})

// leaving resets/hides the menu
document.querySelector('#headerNavShop').addEventListener('mouseleave', function () {
    document.querySelector('#headerNavShopMenu').classList.remove('active');
    document.querySelector('body').classList.remove('noScroll');
    customerPage ? header.style.backgroundColor = '#a9905d' : "";
})

// hovering over main titles activates content
document.querySelectorAll('.headerNavShopMenuMainButton')?.forEach(button => {
    // when list items hovered over, replace content in megamenu
    button.addEventListener('mouseover', function () {
        const title = this.dataset.title;
        // show middle section
        document.querySelectorAll(`.headerNavShopMenuBodySection`).forEach(el => el.classList.remove('active'));
        document.querySelector(`.headerNavShopMenuBodySection[data-title="${title}"]`)?.classList.add('active');
        // show image sections
        document.querySelectorAll(`.headerNavShopMenuImagesItem`).forEach(el => el.classList.remove('active'));
        document.querySelector(`.headerNavShopMenuImagesItem[data-title="${title}"]`)?.classList.add('active');
    })
})

// collection title hover, show individual images
document.querySelectorAll('.headerNavShopMenuBodySectionListItem').forEach(item => {
    if (!item.dataset.title) return;
    item.addEventListener('mouseover', function () {
        // category is for grouping, title is for the specific collection hovered over
        const category = this.parentElement.dataset.title;
        const title = this.dataset.title;
        // show middle section
        document.querySelectorAll(`.headerNavShopMenuImagesItem[data-title="${category}"] .headerNavShopMenuImagesItemCollection`).forEach(el => el.classList.remove('active'));
        document.querySelector(`.headerNavShopMenuImagesItemCollection[data-title="${title}"]`)?.classList.add('active');
    })
})

/**************
 Mobile Nav
 ***************/

// nested menus
// layer one
document.querySelector('#sliderNavExpandButton').addEventListener('click', function () {
    this.closest('#sliderContent').classList.add('expand');
})

// layer 2
document.querySelectorAll('.sliderNavExpandSectionButton').forEach(button => {
    button.addEventListener('click', function () {
        document.querySelectorAll('.sliderNavExpandSection').forEach(el => el.classList.remove('active'));
        this.nextElementSibling.classList.add('active');
    })
})

// return button
document.querySelector('#sliderNavExpandButtonClose').addEventListener('click', function () {
    if (document.querySelector('.sliderNavExpandSection.active')) {
        document.querySelector('.sliderNavExpandSection.active').classList.remove('active');
    } else {
        this.closest('#sliderContent').classList.remove('expand');
    }
})

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
    document.querySelector("#sliderContent").style.height =
        `${window.innerHeight - header.getBoundingClientRect().bottom}px`;
    document.querySelector("#sliderContent").style.top = `${header.getBoundingClientRect().bottom}px`;
    header.classList.add('active');
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    header.classList.remove('active');
    setTimeout(() => {
        document.querySelector("#slider").close();
    }, 550)
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));





